//   <script src="https://api.revy.io/upsell.js" type="text/javascript" defer></script>  
//   插件回调文档地址：https://help.revy.io/article/123-revy-upsell-callbacks#on-add-cart-callback  

//   window.revyUpsellConfig = {
//     disableApp: false,
//     productFormSelector: '#AddToCartForm',
//     // addToCartSelector: ".product-form__cart-submit"F
//     // disableInterceptor: true
//     // disableFormTriggers: true
//   };


//   没有设置upsell产品的回调
window.revyUpsellDataLayer = window.revyUpsellDataLayer || [];
window.revyUpsellDataLayer.push({
    onNoneOfferCallbacks: function () {
        //   jQuery('body').toggleClass('iscartpopup');
        // console.log('onNoneOfferCallbacks');
    },
});
// Runs when the Upsell popup shows.
window.revyUpsellDataLayer = window.revyUpsellDataLayer || [];
window.revyUpsellDataLayer.push({
    onShowPopupCallbacks: function () {
        console.log('onShowPopupCallbacks Callback running!');
        // document.querySelector('cart-drawer').open();
    },
});
// Runs when the cart changes, this callback is recommended to keep Cart Drawers/Mini Cart of themes updated.
window.revyUpsellDataLayer = window.revyUpsellDataLayer || [];
window.revyUpsellDataLayer.push({
    onCartChangeCallbacks: function () {
        console.log('onCartChangeCallbacks Callback running!');
        console.log('YOUR CODE RUNS HERE');
        // 插件会影响购物车数量更新和侧边购物车的打开，需手动打开购物车
        document.querySelector('cart-drawer-items').onCartUpdate();
        if ($('cart-drawer').hasClass('is-empty')) {
            $('cart-drawer').removeClass('is-empty');
            $('.drawer__inner-empty').addClass('hide');
        }
        // 更新导航栏中购物车数量
        fetch(window.location.href, {
            credentials: 'same-origin',
            method: 'GET',
        }).then(function (response) {
            response.text().then(function (content) {
                var tempElement = document.createElement('div');
                tempElement.innerHTML = content;
                document.querySelector('#cart-icon-bubble').innerHTML =
                    tempElement.querySelector('#cart-icon-bubble').innerHTML;
            });
        });
        document.querySelector('cart-drawer').open();
    },
});

// onClosePopupCallbacks
window.revyUpsellDataLayer = window.revyUpsellDataLayer || [];
window.revyUpsellDataLayer.push({
    onClosePopupCallbacks: function () {
        console.log('onClosePopupCallbacks');
    },
});
